import { i18n } from "../../i18n";

interface SelectSellerComparison {
  imageUrl: string;
  productTitle: string;
}

export const SelectSellerComparison = ({
  imageUrl,
  productTitle,
}: SelectSellerComparison) => {
  return (
    <section class="tw:p-3 tw:bg-fruugo-off-white tw:flex tw:gap-3">
      <img
        src={imageUrl}
        width="86"
        class="tw:w-21.5 tw:h-auto tw:self-start"
        aria-hidden={true}
      />
      <div class="tw:flex tw:flex-col tw:w-full tw:justify-center">
        <p class="tw:mb-1 tw:uppercase tw:text-sm tw:font-semibold tw:text-fruugo-accessible-border-control">
          {i18n("product.multi-merchant.menu.comparing")}
        </p>
        <h3 class="tw:text-lg tw:font-semibold tw:text-fruugo-black tw:line-clamp-2 tw:m-0">
          {productTitle}
        </h3>
      </div>
    </section>
  );
};
